import { connect } from 'react-redux';
import SymptomsLevel from './SymptomLevel';

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SymptomsLevel);



// WEBPACK FOOTER //
// ./src/components/SymptomLevel/index.js